import React from 'react'

import { Modal } from '@clientbase/clientbase-library'
import { InvoiceParams } from 'models/Invoice'
import BodyModalNewChargeOrRecurrence, {
  ChargeBodyModalClientProps
} from 'templates/Customers/Modals/BodyModalNewChargeOrRecurrence/BodyModalNewChargeOrRecurrence'

type EditChargeProps = Pick<ChargeBodyModalClientProps, 'handleCloseModal'>

type ModalEditChargeUnifiedProps = {
  isOpenModalEditCharge: boolean
  uuid: string
  charge: InvoiceParams
  reloadCharge: () => void
  setReloadTable?: React.Dispatch<React.SetStateAction<boolean>>
  handleCloseModal?: (refresh?: boolean) => void
} & EditChargeProps

/**
 * Componente unificado para edição de cobranças
 * Utiliza o mesmo componente de criação de cobranças, mas no modo de edição
 */
const ModalEditChargeUnified = ({
  isOpenModalEditCharge,
  handleCloseModal,
  uuid,
  charge,
  reloadCharge,
  setReloadTable,
  ...rest
}: ModalEditChargeUnifiedProps) => {
  const resetCharge = () => {
    reloadCharge()
    !!setReloadTable && setReloadTable((s) => !s)
  }

  const handleClose = (refresh?: boolean) => {
    if (handleCloseModal) {
      handleCloseModal(refresh)
    }
    // Só atualiza a tabela se refresh for true (uma edição foi realizada)
    if (refresh) {
      resetCharge()
    }
  }

  return (
    <Modal
      handleClose={() => handleClose(false)}
      open={isOpenModalEditCharge}
      disablePortal={false}
      width="100%"
      maxWidth="85vw"
      maxHeight="90vh"
      height="auto"
    >
      <BodyModalNewChargeOrRecurrence
        handleCloseModal={handleClose}
        onClose={handleClose}
        isCharge={true}
        isEdit={true}
        editType="charge"
        editData={charge}
        uuid={uuid}
        nameCustomer={charge?.customer?.name || undefined}
        revalidateTable={resetCharge}
        {...rest}
      />
    </Modal>
  )
}

export default ModalEditChargeUnified
